<template>
  <v-dialog v-if="opened" v-model="opened" max-width="600" persistent>
    <v-form ref="formMemberProgress" v-model="valid" @submit.prevent="save()">
      <v-card :loading="loadingData" :disabled="loadingData">
        <v-card-title class="h-100">
          <div class="d-flex align-items-center">
            {{ !id ? " Tambah" : "Ubah" }} 
            <v-btn icon @click="close()" class="ml-auto">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row justify="center" no-gutters>
              <v-col cols="12" md="10">
                  <v-text-field
                    label="Berat Badan (kg)"
                    dense
                    outlined
                    v-model="data.weight"
                    @keypress="isNumber($event)"
                  ></v-text-field>
  
                  <v-text-field
                    label="Tinggi Badan (cm)"
                    dense
                    outlined
                    v-model="data.height"
                    @keypress="isNumber($event)"
                  ></v-text-field>
  
                  <v-text-field
                    label="BMI"
                    dense
                    outlined
                    v-model="data.bmi"
                    @keypress="isNumber($event)"
                  ></v-text-field>
  
                  <v-text-field
                    label="Body Fat Percentage (%)"
                    dense
                    outlined
                    v-model="data.body_fat_percentage"
                    @keypress="isNumber($event)"
                  ></v-text-field>
  
                  <v-text-field
                    label="Muscle Mass (kg)"
                    dense
                    outlined
                    v-model="data.muscle_mass"
                    @keypress="isNumber($event)"
                  ></v-text-field>
  
                  <v-text-field
                    label="Body Water Percentage (%)"
                    dense
                    outlined
                    v-model="data.body_water_percentage"
                    @keypress="isNumber($event)"
                  ></v-text-field>
  
                  <v-text-field
                    label="Bone Mass (kg)"
                    dense
                    outlined
                    v-model="data.bone_mass"
                    @keypress="isNumber($event)"
                  ></v-text-field>
  
                  <v-text-field
                    label="Visceral Fat Level"
                    dense
                    outlined
                    v-model="data.visceral_fat_level"
                    @keypress="isNumber($event)"
                  ></v-text-field>
  
                  <date-picker
                    label="Tanggal Pengukuran"
                    valueType="format"
                    format="YYYY-MM-DD"
                    v-model="data.measurement_date"
                  ></date-picker>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-row no-gutters>
            <v-col cols="12" class="d-flex justify-end">
              <v-btn
                depressed
                class="ma-1"
                :disabled="loading"
                @click="close()"
              >
                <v-icon small left>mdi-close</v-icon>
                Tutup
              </v-btn>
              <v-btn
                type="submit"
                color="success"
                depressed
                class="ma-1"
                :loading="loading"
                :disabled="loading"
                @click.prevent="save()"
              >
                <v-icon small left>mdi-content-save</v-icon>
                Simpan
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import ApiService from "@/core/services/api.service";

import { isNumber } from "@/core/utils";
import moment from "moment";

export default {
  data() {
    return {
      action: "create",
      id: null,
      opened: false,
      loading: false,
      loadingData: false,
      valid: true,
      listZone: [],
      isLoadingZone: false,
      listRole: [],
      search: "",
      data: {
        user_id: null,
        weight: 0,
        height: 0,
        bmi: 0,
        body_fat_percentage: 0,
        muscle_mass: 0,
        body_water_percentage: 0,
        bone_mass: 0,
        visceral_fat_level: 0,
        measurement_date: null
      }
    };
  },
  props: {
    success: {
      type: Function,
      default: function() {}
    }
  },
  async mounted() {
    // this.getListZone();
    // this.getRoles();
  },
  methods: {
    async getRoles() {
      const { data } = await ApiService.get("role/list");
      this.listRole = data.filter(role => role.name.toLowerCase() !== "member");
      // this.listRole = data;
    },
    open(userId, id) {
      if (!userId) {
        return;
      }
      this.data.user_id = userId;
      this.opened = true;
      setTimeout(() => {
        this.$refs.formMemberProgress.reset();
        if (id) {
          this.getData(id);
        }
      }, 1);
    },
    async getData(id) {
      this.loadingData = true;
      ApiService.get("member-progress?id=" + id)
        .then(({ data }) => {
          this.data = {
            user_id: data.user_id,
            weight: data.weight || 0,
            height: data.height || 0,
            bmi: data.bmi || 0,
            body_fat_percentage: data.body_fat_percentage || 0,
            muscle_mass: data.muscle_mass || 0,
            body_water_percentage: data.body_water_percentage || 0,
            bone_mass: data.bone_mass || 0,
            visceral_fat_level: data.visceral_fat_level || 0,
            measurement_date: data.measurement_date
              ? moment(data.measurement_date).format("YYYY-MM-DD")
              : null
          };
          this.id = id;
          this.loadingData = false;
        })
        .catch(({ response }) => {
          if (response.data) {
            this.handleError(response.data);
          }
          this.loadingData = false;
        });
    },
    async save() {
      this.$refs.formMemberProgress.validate();
      if (this.valid) {
        this.loading = true;
        this.data.member_id = this.data.user_id;
        const action = !this.id ? "post" : "update";
        let url = "member-progress";
        if (this.id) {
          url = url + "?id=" + this.id;
        }
        ApiService[action](url, this.data)
          .then(({ data }) => {
            if (data.id) {
              this.loading = false;
              this.success(data);
              this.$swal.fire({
                icon: "success",
                title: "Berhasil",
                text: "Data berhasil disimpan",
                showConfirmButton: false,
                timer: 3000
              });
              this.close();
            }
          })
          .catch(({ response }) => {
            if (response.data) {
              this.handleError(response.data);
            }

            this.loading = false;
          });
      }
    },
    handleError(data) {
      if (data.error) {
        this.$swal.fire({
          icon: "warning",
          title: "Terjadi kesalahan",
          text: data.error,
          showConfirmButton: true,
          timer: 5000
        });
      }
    },
    close() {
      this.opened = false;
      this.id = null;
      this.data.user_id = null;
      (this.listZone = []), (this.isLoadingZone = false);
      this.search = "";
      this.$refs.formMemberProgress.reset();
    },
    isNumber
  },
  watch: {
    
  }
};
</script>
